import { createAction } from '@reduxjs/toolkit'

import { Gift } from '../types/gifts'

export const addedProductToCartEvent = createAction<{
	productId: number
	gift: Gift | null | undefined
	location?: string
}>('cart/added-product-to-cart')

export const removedProductFromCartEvent = createAction<{
	productId: number
}>('cart/removed-product-from-cart')

export const selectedGiftForProductEvent = createAction<{
	gift: Gift
}>('cart/selected-gift-for-product')

export const removedGiftForProductEvent = createAction<{
	gift: Gift
}>('cart/removed-gift-for-product')
